import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import InquiryForm from "../InquiryForm/InquiryForm";

const ServiceLeadModal = ({ show, onHide, title, page, calendlyUrl = "" }) => {
  const resolvedCalendlyUrl = calendlyUrl.trim();
  const [isCalendlyLoading, setIsCalendlyLoading] = useState(true);
  // ESC key + body scroll lock
  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onHide(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [show, onHide]);

  useEffect(() => {
    if (show && resolvedCalendlyUrl) {
      setIsCalendlyLoading(true);
    }
  }, [show, resolvedCalendlyUrl]);

  if (!show || typeof document === "undefined") return null;

  return createPortal(
    <>
      <style>{`
        .slm-backdrop {
          position: fixed; inset: 0; z-index: 1060;
          background: rgba(15,23,42,0.55);
          backdrop-filter: blur(3px);
          display: flex; align-items: center; justify-content: center;
          padding: 16px;
          animation: slm-fade-in 0.18s ease;
        }
        .slm-box {
          position: relative;
          width: 100%; max-width: 700px;
          max-height: 90vh; overflow-y: auto;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 24px 64px rgba(0,0,0,0.2);
          animation: slm-scale-in 0.2s ease;
        }
        .slm-header {
          position: sticky; top: 0; z-index: 2;
          background: #00b074;
          border-radius: 20px 20px 0 0;
          padding: 12px 24px;
          display: flex; align-items: center; justify-content: space-between;
        }
        .slm-title {
          font-size: 16px; font-weight: 700; color: #fff;
          margin: 0; line-height: 1.3;
        }
        .slm-close {
          width: 28px; height: 28px; border-radius: 50%;
          background: rgba(255,255,255,0.18); border: none;
          color: #fff; font-size: 16px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; transition: background 0.15s;
        }
        .slm-close:hover { background: rgba(255,255,255,0.32); }
        .slm-body { padding: 0; }
        .slm-box--calendly { max-width: 820px; overflow: hidden; }
        .slm-calendly { position: relative; width: 100%; height: 620px; max-height: calc(86vh - 56px); min-height: 520px; overflow: hidden; box-sizing: border-box; background: #fff; }
        .slm-calendly iframe { display: block; width: 100%; height: calc(100% + 54px); border: 0; opacity: 1; transform: translateY(-54px); transition: opacity 0.15s ease; }
        .slm-calendly iframe.is-loading { opacity: 0; }
        .slm-loader { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: #fff; color: #0f172a; font-size: 15px; font-weight: 700; z-index: 1; }
        .slm-spinner { width: 30px; height: 30px; border: 3px solid #dbeafe; border-top-color: #00b074; border-radius: 50%; animation: slm-spin 0.8s linear infinite; margin-right: 10px; }
        @keyframes slm-spin { to { transform: rotate(360deg); } }
        @media (max-width: 480px) {
          .slm-calendly { height: calc(100vh - 58px); max-height: none; min-height: 500px; }
          .slm-calendly iframe { height: calc(100% + 36px); transform: translateY(-36px); }
        }
        @keyframes slm-fade-in {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes slm-scale-in {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to   { opacity: 1; transform: scale(1)    translateY(0); }
        }
        @media (max-width: 480px) {
          .slm-box { border-radius: 16px; }
          .slm-body { padding:0; }
        }
      `}</style>

      {/* Backdrop — click outside closes */}
      <div className="slm-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onHide(); }}>
        <div className={`slm-box${resolvedCalendlyUrl ? " slm-box--calendly" : ""}`}>
          <div className="slm-header">
            <h2 className="slm-title">{title}</h2>
            <button type="button" className="slm-close" onClick={onHide} aria-label="Close">
              ✕
            </button>
          </div>
          <div className="slm-body">
            {resolvedCalendlyUrl ? (
              <div className="slm-calendly">
                {/* Current code: <InquiryForm page={page} /> */}
                {isCalendlyLoading && (
                  <div className="slm-loader">
                    <span className="slm-spinner" aria-hidden="true" />
                    Loading calendar...
                  </div>
                )}
                <iframe
                  src={resolvedCalendlyUrl}
                  title="Book Demo"
                  loading="lazy"
                  className={isCalendlyLoading ? "is-loading" : ""}
                  onLoad={() => setIsCalendlyLoading(false)}
                />
              </div>
            ) : (
              <InquiryForm page={page} />
            )}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default ServiceLeadModal;
